'use client'

import { api } from '@/features/veluvit/services/api'
import { adultStatusSchema } from '@/features/veluvit/schemas/api.schema'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

import type {
  AdultStatus,
  Preset,
  PresetId,
} from '@/features/veluvit/types/api.types'

/* 성인모드 인증 상태 — 잠금 해제 근거는 언제나 서버 값(config.adult.eligible)이다.
   화면이 기억한 상태나 본인확인 성공 여부(identity.verified)로 열지 않는다. */

export const ADULT_REQUIRED = 'ADULT_VERIFICATION_REQUIRED'
let refreshing: {
  identity: number
  userId: string | null
  promise: Promise<AdultStatus>
} | null = null

/** 성인 인증 상태·프리셋 목록을 서버에서 다시 받아 세션에 넣는다 */
export function refreshAdult(): Promise<AdultStatus> {
  const initial = useSessionStore.getState()
  const identity = initial.identity
  const userId = initial.data?.user?.id ?? null
  if (refreshing?.identity === identity && refreshing.userId === userId)
    return refreshing.promise
  const promise = (async () => {
    const data = await api<{
      presets: Preset[]
      default: PresetId
      adult: AdultStatus
    }>('/preset/')
    adultStatusSchema.parse(data.adult)
    const state = useSessionStore.getState()
    if (
      state.identity !== identity ||
      (state.data?.user?.id ?? null) !== userId
    )
      throw new Error('계정이 바뀌어 이전 인증 상태 조회를 종료했어요.')
    const session = state.data
    if (session) {
      useSessionStore.setState({
        data: {
          ...session,
          config: {
            ...session.config,
            presets: data.presets,
            defaultPreset: data.default,
            adult: data.adult,
          },
        },
      })
    }
    return data.adult
  })().finally(() => {
    if (refreshing?.promise === promise) refreshing = null
  })
  refreshing = { identity, userId, promise }
  return promise
}
